import { render, staticRenderFns } from "./FullReduction.vue?vue&type=template&id=99d8e594&scoped=true&"
import script from "./FullReduction.vue?vue&type=script&lang=js&"
export * from "./FullReduction.vue?vue&type=script&lang=js&"
import style0 from "./FullReduction.vue?vue&type=style&index=0&id=99d8e594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d8e594",
  null
  
)

export default component.exports